import React from "react";
import { Card, Table, Button, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import generateUserLoginDetailsExcel from "../../Utils/UserLoginDetailsExcel";
import { generatePDF } from "../../Utils/pdfExport";

const UserLoginDetailsTable = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { tableData, reportTitle } = location.state || {};

    if (!tableData || tableData.length === 0) {
        navigate(-1);
        return null;
    }

    const enrichedData = tableData.map((item, idx) => ({
        ...item,
        index: idx + 1,
        loginStatus: item.logoutTime ? "Logged Out" : "Active",
        sessionDuration: item.loginTime && item.logoutTime
            ? (() => {
                const diffMs = new Date(item.logoutTime) - new Date(item.loginTime);
                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                return `${hours}h ${minutes}m`;
            })()
            : "-"
    }));

    const handleExportExcel = () => {
        generateUserLoginDetailsExcel(tableData);
        message.success("Excel report generated successfully");
    };

    const handleExportPDF = () => {
        const columns = [
            { title: "No.", dataIndex: "index", key: "index" },
            { title: "Login Time", dataIndex: "loginTime", key: "loginTime" },
            { title: "Logout Time", dataIndex: "logoutTime", key: "logoutTime" },
            { title: "Username", dataIndex: "name", key: "name" },
            { title: "IP Address", dataIndex: "ipAddress", key: "ipAddress" },
            { title: "Login Status", dataIndex: "loginStatus", key: "loginStatus" },
            { title: "Session Duration", dataIndex: "sessionDuration", key: "sessionDuration" },
        ];
        generatePDF(reportTitle, columns, enrichedData);
    };

    return (
        <div style={{ padding: 10 }}>
            <Card style={{ border: '1px solid #f0f0f0', borderRadius: '5px', boxShadow: '0 2px 8px rgba(51, 39, 39, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                    <Button type="default" onClick={() => navigate(-1)}>
                        Back
                    </Button>
                    <h3 style={{ margin: 0 }}>{reportTitle}</h3>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button type="primary" onClick={handleExportExcel} icon={<span>📊</span>}>
                            Export Excel
                        </Button>
                        <Button type="default" onClick={handleExportPDF} icon={<span>📄</span>}>
                            Export PDF
                        </Button>
                    </div>
                </div>
                <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                    <Table
                        dataSource={enrichedData}
                        columns={[
                            { title: "No.", dataIndex: "index", key: "index", width: 60 },
                            { title: "Login Time", dataIndex: "loginTime", key: "loginTime", width: 180 },
                            { title: "Logout Time", dataIndex: "logoutTime", key: "logoutTime", width: 180 },
                            { title: "Username", dataIndex: "name", key: "name", width: 180 },
                            { title: "IP Address", dataIndex: "ipAddress", key: "ipAddress", width: 150 },
                            { title: "Login Status", dataIndex: "loginStatus", key: "loginStatus", width: 120 },
                            { title: "Session Duration", dataIndex: "sessionDuration", key: "sessionDuration", width: 150 },
                        ]}
                        bordered
                        pagination={false}
                        size="middle"
                        rowClassName={(record, index) => index % 2 === 1 ? 'ant-table-row-alt' : ''}
                    />
                </div>
            </Card>
        </div>
    );
};

export default UserLoginDetailsTable;